import React, { useEffect } from "react";
import { useStore } from "../Context";
import useTheme from "../hooks/useTheme";
import loanlogs from "../services/loanlogs";

function End() {
    const { userName } = useStore();

    const theme = useTheme();
    
    function handleClose () {
        window.opener = null;
        window.open("", "_self");
        window.close();
    };

    useEffect(() => {
        loanlogs.success('/end').catch(console.log)
    }, []);

    return (
        <main className="page-step">
            <header className="page-header">
                <h1 className="text-center text-3xl">¡Trámite finalizado {userName}!</h1>
            </header>
            <div className="page-content self-center">
                <img src={`/${theme}/logo.png`} alt="" width="300" className="image-logo" />
            </div>
            <div className="page-actions flex-column">
                <button className="button-primary" onClick={handleClose}>
                    Cerrar
                </button>
            </div>
        </main>
    );
}

export default End;
